import * as api from 'api';
import { actionTypes } from 'redux-resource';
import { SubmissionError } from 'redux-form';
import { PER_PAGE } from 'helpers/actions';

export const fetchAllInsuranceContracts = (page, filters) => (dispatch) => {
  const { att_subscription, user_profile } = filters;
  let subscriptionListKey = '';

  if (att_subscription) {
    subscriptionListKey = `_att_subscription${att_subscription}`;
    if (user_profile) {
      subscriptionListKey += `_user_profile_${user_profile}`;
    }
  }

  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: `fetchAll${page}`,
    list: `page${page}${subscriptionListKey}`,
    mergeListIds: false,
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchAllInsuranceContracts(page, filters)
    .then(async (response) => {
      const { results, count, next, previous } = response.data;

      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: results || [],
        requestProperties: {
          perPage: (results && results.length) || PER_PAGE,
          count,
          next,
          previous,
        },
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const fetchUserContracts = (userId) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'all',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchUserInsuranceContracts(userId)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: response.data.results,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const fetchSprintSubContract = (sub) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'all',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchSprintSubContract(sub)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: response.data.results,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const fetchAttSubContract = (sub) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'all',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchAttSubContract(sub)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: response.data.results,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const fetchQuickSubContract = (subId) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'all',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchQuickSubContract(subId)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: response.data.results,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const fetchTracfoneSubContract = (sub) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'all',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchTracfoneSubContract(sub)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: response.data.results,
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const createContract = (contract) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'create',
    list: 'insuranceContracts',
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.CREATE_RESOURCES_PENDING,
  });

  return api
    .createInsuranceContract(contract)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.CREATE_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.CREATE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError(messages);
    });
};

export const updateContract =
  ({ id, ...attrs }) =>
  (dispatch) => {
    const actionDefaults = {
      resourceType: 'insuranceContracts',
      requestKey: 'save',
      resources: [id],
    };

    dispatch({
      ...actionDefaults,
      type: actionTypes.UPDATE_RESOURCES_PENDING,
    });

    return api
      .updateInsuranceContract(id, attrs)
      .then((response) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
          resources: [response.data],
        });
      })
      .catch((err) => {
        dispatch({
          ...actionDefaults,
          type: actionTypes.UPDATE_RESOURCES_FAILED,
        });

        let messages = err.response
          ? err.response.data
          : { detail: 'Something went wrong' };
        throw new SubmissionError(messages);
      });
  };

export const findContract = (id) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'find',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.READ_RESOURCES_PENDING,
  });

  return api
    .fetchInsuranceContract(id)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_SUCCEEDED,
        resources: [response.data],
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.READ_RESOURCES_FAILED,
      });
    });
};

export const activateContract = (id) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'activateContract',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.UPDATE_RESOURCES_PENDING,
  });

  return api
    .activateInsuranceContract(id)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
        meta: {
          activation: {
            ...response.data,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      throw new SubmissionError(messages);
    });
};

export const cancelContract = (id, cancel) => (dispatch) => {
  const actionDefaults = {
    resourceType: 'insuranceContracts',
    requestKey: 'cancelContract',
    resources: [id],
  };

  dispatch({
    ...actionDefaults,
    type: actionTypes.UPDATE_RESOURCES_PENDING,
  });

  return api
    .cancelInsuranceContract(id, cancel)
    .then((response) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_SUCCEEDED,
        meta: {
          cancellation: {
            ...response.data,
          },
        },
      });
    })
    .catch((err) => {
      dispatch({
        ...actionDefaults,
        type: actionTypes.UPDATE_RESOURCES_FAILED,
      });

      let messages = err.response
        ? err.response.data
        : { detail: 'Something went wrong' };
      if (messages.detail) {
        throw new SubmissionError({ _error: messages });
      } else if (messages.message || messages.error) {
        throw new SubmissionError({
          _error: messages.message || messages.error,
        });
      } else {
        throw new SubmissionError(messages);
      }
    });
};
